// tslint:disable

import * as classNames from "classnames";
import * as React from "react";

import "react-google-maps";

import { HTMLDivProps } from "@blueprintjs/core";

import { Circle, Rectangle, Polygon } from "react-google-maps";

export interface IShapesProps extends HTMLDivProps {
  shape?: any;
  onShapeMounted(event: any): void;
}

import "./styles.css";

export const Shapes: React.SFC<IShapesProps> = props => {
  const { className, shape, onShapeMounted } = props;
  const classes = classNames("geo-map-controls-container", className);

  return (
    <div className={classes}>
      {shape && shape.type === "circle" ? (
        <Circle
          options={{
            strokeColor: "#1f76ff",
            fillOpacity: 0.15,
            strokeWeight: 4,
            strokeOpacity: 1,
            clickable: false,
            zIndex: 1
          }}
          ref={props.onShapeMounted}
          center={shape.center}
          radius={shape.radius}
        />
      ) : shape && shape.type === "rectangle" ? (
        <Rectangle
          options={{
            strokeColor: "#1f76ff",
            fillOpacity: 0.15,
            strokeWeight: 4,
            strokeOpacity: 1,
            clickable: false,
            zIndex: 1
          }}
          ref={onShapeMounted}
          bounds={shape.bounds}
        />
      ) : (
        shape &&
        shape.type === "polygon" && (
          <Polygon
            options={{
              strokeColor: "#1f76ff",
              fillOpacity: 0.15,
              strokeWeight: 4,
              strokeOpacity: 1,
              clickable: false,
              zIndex: 1
            }}
            ref={props.onShapeMounted}
            paths={shape.paths}
          />
        )
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controllers/alerts/components/maps/geo-map/shapes.tsx